import { useMemo } from "react";

import { some } from "lodash/fp";

import {
  ProgressItemEnum,
  ProgressItemState,
} from "@app/analytics/GettingStarted/types";
import { isProgressItemCompleted } from "@app/analytics/GettingStarted/utils";
import useIntegrations from "@app/analytics/hooks/integrations/useIntegrations";
import { PRODUCTIVITY_PROVIDERS } from "@app/common/constants/providers";

export const useGetIntegrationState = (progress: number): ProgressItemState => {
  const isCompleted = isProgressItemCompleted(
    progress,
    ProgressItemEnum.INTEGRATION
  );

  const { isProviderConnected, isLoading: isLoadingIntegrations } =
    useIntegrations({
      enabled: !isCompleted,
    });

  const hasAtLeastOneIntegration = useMemo(() => {
    if (isLoadingIntegrations) return false;
    return (
      isCompleted ||
      some(
        (provider) =>
          isProviderConnected({ providerId: provider.id, scope: "user" }),
        PRODUCTIVITY_PROVIDERS
      )
    );
  }, [isCompleted, isLoadingIntegrations, isProviderConnected]);

  const isUnmarkedComplete = hasAtLeastOneIntegration && !isCompleted;

  const state = isUnmarkedComplete
    ? "unmarked_complete"
    : isCompleted
      ? "complete"
      : "todo";

  return useMemo(
    () => ({
      type: ProgressItemEnum.INTEGRATION,
      state,
    }),
    [state]
  );
};

export default useGetIntegrationState;
